import React from 'react'
import {
  CFSelect,
  CFView,
  CFImage,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { orderPickupButton } from 'images'
import { dispatch } from 'store'

export default () => {
  return (
    <CFSelect selector={dispatch.restaurant.getSelectedLocationId}>
      {locationId => (
        <CFView>
          <MobileScreen>
            <a
              href={`https://order.codefusion.tech/restaurants/nZMz6tJEkc2Fi7UNPwow/locations/M0kkQlppT20gqRWvN7ph`}
              target="_blank"
            >
              <CFView hover>
                <CFImage
                  src={orderPickupButton}
                  w="70%"
                  maxnWidth="210px"
                  alt="About"
                />
              </CFView>
            </a>
          </MobileScreen>
          <DefaultScreen>
            <a
              href={`https://order.codefusion.tech/restaurants/nZMz6tJEkc2Fi7UNPwow/locations/M0kkQlppT20gqRWvN7ph`}
              target="_blank"
            >
              <CFView hover>
                <CFImage
                  src={orderPickupButton}
                  w="100%"
                  maxWidth="240px"
                  alt="About"
                />
              </CFView>
            </a>
          </DefaultScreen>
        </CFView>
      )}
    </CFSelect>
  )
}
